import { useTranslation } from 'react-i18next'
import ebookLogo from '../../assets/logos/ebook.png'
import styles from './ebook-page.module.scss'
import { ContactForm } from '../../components'


const EbookPage = () => {
  const [t] = useTranslation()
  const googleSheetUrl='https://script.google.com/macros/s/AKfycbxk-Xj-492099unJdTjG9jRLCU9vxjCoDF770cOoaYegtqalT8ajspLYFioN4ECUpqn0w/exec'
  return (
    <div className={styles.container}>
          <h1>Regístrate y Descarga el eBook </h1>
       <div className={styles.description_image_wrapper}>
        <div className={styles.ebook_name_description}>
          <h2>“Viaje al centro de la convivencia escolar”</h2>
          <p>
          Nuestro eBook reúne conocimientos y estrategias sobre convivencia escolar, desarrollados por nuestro equipo de analítica avanzada. Ofrece herramientas para fomentar entornos educativos positivos y amigables, basados en la experiencia adquirida con nuestro software, que recopila datos escolares para proporcionar enfoques precisos y concretos.
          </p>
        </div>
        <div className={styles.image_container}>
          <img className={styles.image} src={ebookLogo} alt='ebook Logo'/>
        </div>
       </div>
       <div className={styles.form_theme_wrapper}>
        <div className={styles.ebook_themes}>
          <h3>¿Qué temáticas abordamos en este eBook?</h3>
          <ul>
            <li>Notas realizadas por un equipo especializado que amplían la comprensión sobre la convivencia escolar en toda la comunidad educativa.</li>
            <li>Un camino para construir relaciones sólidas entre toda tu comunidad educativa en donde todos y todas se sientan cómodos.</li>
            <li>Indagar problemáticas que se generan en el interior del Aula respaldadas por experiencias e investigación.</li>
          </ul>
        </div>
        <div className={styles.form_ebook}>
          <h3>¡Rellena el formulario de contacto para recibir este material y únete a nuestra comunidad comprometida en mejorar la convivencia en el entorno educativo!</h3>
         <ContactForm 
              googleSheetUrl={googleSheetUrl}  
              alertMessageError={t('section.contact.form.errorMessage')} 
              alertMessageSuccess='Muchas gracias por interesarte en nuestro Ebook, lo puedes descargar en el siguiente enlace' 
              ebook
              />
              
        </div>
        </div>
    </div>
  )
}

export default EbookPage